var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_1531_62233)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2222 9.6H21.3333V8H19.5556V9.6H12.4444V8H10.6667V9.6H9.77778C8.79111 9.6 8.00889 10.32 8.00889 11.2L8 22.4C8 22.8243 8.1873 23.2313 8.5207 23.5314C8.8541 23.8314 9.30628 24 9.77778 24H22.2222C23.2 24 24 23.28 24 22.4V11.2C24 10.32 23.2 9.6 22.2222 9.6ZM22.2222 22.4H9.77778V14.4H22.2222V22.4ZM13.3333 17.6H11.5556V16H13.3333V17.6ZM16.8889 17.6H15.1111V16H16.8889V17.6ZM20.4444 17.6H18.6667V16H20.4444V17.6ZM13.3333 20.8H11.5556V19.2H13.3333V20.8ZM16.8889 20.8H15.1111V19.2H16.8889V20.8ZM20.4444 20.8H18.6667V19.2H20.4444V20.8Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1531_62233",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.35a1152bf7418cb2771b516619b971aa.svg";
export { ForwardRef as ReactComponent };